import { render, staticRenderFns } from "./com_zxksTip.vue?vue&type=template&id=7b5954aa&scoped=true&"
import script from "./com_zxksTip.vue?vue&type=script&lang=js&"
export * from "./com_zxksTip.vue?vue&type=script&lang=js&"
import style0 from "./com_zxksTip.vue?vue&type=style&index=0&id=7b5954aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5954aa",
  null
  
)

export default component.exports